import {
  convertDateToYYYYMMDDFormat,
  convertEventSelectToTarget,
  CustomDateRangePicker,
  formatDataToLabelValue,
  FormFeedBack,
  PageWrapper,
  Select,
  STATUSPAGE,
} from '@repo/ui';
import { useAccessReport } from 'presentation/app/modules/Reports/hooks/useAccessReport';
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  Label,
  Row,
  Spinner,
} from 'reactstrap';

export const AccessReport = () => {
  const {
    courses,
    firstDayOfMonth,
    handleExportExcelClick,
    loadingCourses,
    loadingExportExcel,
    loadingOrganizations,
    organizations,
    profileOptions,
    today,
    validation,
  } = useAccessReport();

  return (
    <PageWrapper title="Acessos">
      <Col className="mb-3 border-0 d-flex align-items-end justify-content-between">
        <div>
          <h4 className="mb-1">Relatório de Acessos</h4>
          <p className="text-muted mb-0">
            Filtre os acessos por organização, curso, perfil e período.
          </p>
        </div>
      </Col>

      <Card>
        <Form
          autoComplete="off"
          onSubmit={(event) => {
            event.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <CardBody>
            <Row>
              <Col xs={12} md={6} lg={3} className="mb-3">
                <Label htmlFor="entity" className="form-label">
                  Organização:
                </Label>
                <Select
                  isClearable
                  isLoading={loadingOrganizations}
                  id="entity"
                  name="entity"
                  placeholder="Todas as Organizações"
                  value={validation.values.entity}
                  onChange={(value) => {
                    validation.setFieldValue('course', null);
                    validation.handleChange(
                      convertEventSelectToTarget('entity', value),
                    );
                  }}
                  onBlur={validation.handleBlur}
                  options={formatDataToLabelValue(
                    organizations as never,
                    'id',
                    'nome',
                  )}
                />
                <FormFeedBack
                  error={validation.errors.entity?.toString()}
                  isInvalid={
                    !!(validation.touched.entity && validation.errors.entity)
                  }
                />
              </Col>

              <Col xs={12} md={6} lg={3} className="mb-3">
                <Label htmlFor="course" className="form-label">
                  Curso:
                </Label>
                <Select
                  isClearable
                  isLoading={loadingCourses}
                  isDisabled={loadingCourses}
                  id="course"
                  name="course"
                  placeholder="Todos os Cursos"
                  value={validation.values.course}
                  onChange={(value) => {
                    validation.handleChange(
                      convertEventSelectToTarget('course', value),
                    );
                  }}
                  onBlur={validation.handleBlur}
                  options={formatDataToLabelValue(
                    courses as never,
                    'id',
                    'nome',
                  )}
                />
                <FormFeedBack
                  error={validation.errors.course?.toString()}
                  isInvalid={
                    !!(validation.touched.course && validation.errors.course)
                  }
                />
              </Col>

              <Col xs={12} md={6} lg={3} className="mb-3">
                <Label htmlFor="profile" className="form-label">
                  Perfil:
                </Label>
                <Select
                  id="profile"
                  name="profile"
                  value={validation.values.profile}
                  onChange={(value) => {
                    validation.handleChange(
                      convertEventSelectToTarget('profile', value),
                    );
                  }}
                  onBlur={validation.handleBlur}
                  options={profileOptions}
                />
                <FormFeedBack
                  error={validation.errors.profile?.toString()}
                  isInvalid={
                    !!(validation.touched.profile && validation.errors.profile)
                  }
                />
              </Col>

              <Col
                xs={12}
                md={6}
                lg={3}
                className="mb-3 d-flex flex-column justify-content-end"
              >
                <Label htmlFor="access-period" className="form-label">
                  Período:
                </Label>
                <CustomDateRangePicker
                  initialStartDate={firstDayOfMonth}
                  initialEndDate={today}
                  placement="auto"
                  onDateChange={(start, ends) => {
                    validation.setFieldValue(
                      'starts',
                      convertDateToYYYYMMDDFormat(start),
                    );
                    validation.setFieldValue(
                      'ends',
                      convertDateToYYYYMMDDFormat(ends),
                    );
                  }}
                />
              </Col>
            </Row>
          </CardBody>

          <CardFooter className="d-flex justify-content-end gap-3">
            <button
              id="export-excel"
              type="button"
              onClick={handleExportExcelClick}
              className="btn btn-success waves-effect waves-light"
              disabled={loadingExportExcel === STATUSPAGE.LOADING}
            >
              {loadingExportExcel === STATUSPAGE.LOADING ? (
                <Spinner size="sm">{['Carregando...']}</Spinner>
              ) : (
                <>
                  Exportar excel
                  <i className="ri-file-excel-2-line mx-2"></i>
                </>
              )}
            </button>
          </CardFooter>
        </Form>
      </Card>
    </PageWrapper>
  );
};
